// extracted by mini-css-extract-plugin
var _1 = "wHtOsA1lDV";
export { _1 as "root" }
